import { Result } from 'antd';
import { lookupDeniedCopy } from '@bettercomp/ams-spa-auth';

export interface DeniedViewProps {
  /** The denied route's `source` query parameter, null when absent. */
  source: string | null;
  /** The denied route's `code` query parameter, null when absent. */
  code: string | null;
}

export function DeniedView({ source, code }: DeniedViewProps) {
  const copy = lookupDeniedCopy({ source, code });

  return <Result status="403" title={copy.title} subTitle={copy.description} />;
}
